import { cloneDeep, isEqual } from 'lodash';
import errors from '@/modules/_global/mixins/errors';
import { mapGetters } from 'vuex';
export default {
  mixins: [errors],

  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    ...mapGetters(['loading'])
  },

  data() {
    return {
      form: {},
      valid: false,
      formCopy: null,
      editMode: false
    };
  },

  watch: {
    editMode: {
      deep: true,
      immediate: true,
      handler: function(v) {
        if (v) {
          this.formCopy = cloneDeep(this.form);
        }
      }
    },

    value: {
      deep: true,
      immediate: true,
      handler: function(formProps) {
        if (isEqual(formProps, this.form)) {
          return;
        }

        this.form = {
          ...this.form,
          ...formProps
        };

        this.emitter();
      }
    }
  },

  methods: {
    toggleEditMode() {
      this.editMode = !this.editMode;
    },

    emitter() {
      this.$emit('input', this.form);
    },

    cancel() {
      this.$nextTick(() => {
        this.form = cloneDeep(this.formCopy);
        this.toggleEditMode();
        this.$emit('cancel');
      });
    },

    reset() {
      this.$refs.form.reset();
    }
  }
};
